<form class="mc-spring-board" [formGroup]="contactForm" (ngSubmit)="onSubmit()">
  <mat-toolbar class="mc-spring-board-header" color="secondary">
    Contact MadCap Software Sales Team
    <button type="button" mat-icon-button class="mc-dialog-floating-close-button" tabindex="-1" (click)="closeDialog()">
      <mat-icon fontSet="project-titan" fontIcon="icon-close"></mat-icon>
    </button>
  </mat-toolbar>

  <div class="mc-spring-board-body">
    <p class="mc-form-text">If you would like to make changes to your subscription, please contact our Sales team at <span class="mc-license-contact-sales-dialog-phone-number">+1 (858) 320-0387</span> (local) or at <span class="mc-license-contact-sales-dialog-phone-number">+1 (888) MADCAP-1</span> (toll free), or send an email to <a href="mailto:sales@madcapsoftware.com">sales&#64;madcapsoftware.com</a>. Please include your license number, company name, and user details.</p>
    <p class="mc-form-text">Alternatively, you may submit your request using the form below.</p>

    <div class="mc-form-spacer"></div>

    <div class="mc-license-contact-sales-dialog-outer-border mc-border-divider">
      <div class="mc-license-contact-sales-dialog-container mc-license-contact-sales-dialog-bottom-border mc-border-divider">
        <ul class="mc-property-list">
          <li><span class="mc-property-name">License: </span><span class="mc-property-value">{{ license.ShortKey }}</span></li>
          <li><span class="mc-property-name">Company: </span><span class="mc-property-value">{{ license.CompanyName }}</span></li>
          <li><span class="mc-property-name">User: </span><span class="mc-property-value">{{ licenseUser.User.FullName }}</span> (<span class="mc-property-value">{{ licenseUser.User.Email }}</span>)</li>
        </ul>
      </div>

      <div class="mc-form-spacer"></div>

      <div class="mc-license-contact-sales-dialog-container ">
        <p><b>Message to Sales:</b></p>
        <mat-form-field class="mc-form-field" mcColor="secondary">
          <textarea matInput formControlName="message" placeholder="Type your message here." rows="10" maxLength="2000" required></textarea>
          <mat-hint align="end">{{ contactForm.get('message')?.value?.length ?? 0 }} / 2000</mat-hint>
          <mat-error *ngIf="contactForm.get('message')?.hasError('required')">
            Message cannot be empty.
          </mat-error>
        </mat-form-field>
      </div>
    </div>
  </div>

  <div class="mc-spring-board-footer">
    <mc-errors-expansion-panel *ngIf="savingState.generalError$ | async as generalError" compact [generalError]="generalError" [detailedErrors]="savingState.detailedErrors$ | async"></mc-errors-expansion-panel>

    <div class="mc-form-buttons">
      <button type="button" mat-stroked-button (click)="closeDialog()">Cancel</button>
      <button type="submit" mat-raised-button color="primary" [disabled]="contactForm.invalid">Send</button>
    </div>
  </div>

  <mc-loader *ngIf="savingState.loading$ | async" class="mc-loader-semi-transparent"></mc-loader>
</form>